import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'

/**
 * Temp feature flag to enable Conversational Intake and Rec Engine for Omneans only
 * This supports testing on customer data without having to enable usage for end users
 */
export const useIsOmneansConvIntake = () => {
  const { OMNEANS_ONLY_CONV_INTAKE } = useFeatureFlags()
  const { user } = useAuthenticatedUser()
  const convIntakeEnabledForCurrentUser = Boolean(OMNEANS_ONLY_CONV_INTAKE && user.isOmnean)
  return { convIntakeEnabledForCurrentUser }
}
